import { useAuth } from "../context/AuthContext";
import { Sunburst } from "../components/Sunburst";

export default function UnderConstruction() {
  const { user, login, logout } = useAuth();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center relative" data-testid="under-construction-page">
      <Sunburst />
      <div className="relative z-10 text-center px-6">
        <img src="/eb-logo.png" alt="Eternal Biolabs" className="w-20 h-20 mx-auto mb-8 object-contain" />
        <h1 className="font-display text-2xl sm:text-4xl uppercase tracking-[0.2em] text-[#1A1A1A]">Under Construction</h1>

        {user && !user.is_admin ? (
          <div className="mt-10">
            <p className="text-sm text-[#6E675F]" data-testid="construction-admins-only">
              Signed in as {user.email} — administrator access only.
            </p>
            <button
              data-testid="construction-signout-button"
              onClick={logout}
              className="mt-6 text-xs tracking-[0.2em] uppercase font-semibold text-[#8C7B6B] hover:text-[#75665A] transition-colors"
            >
              Sign Out
            </button>
          </div>
        ) : (
          <button
            data-testid="construction-login-button"
            onClick={login}
            className="mt-10 bg-[#8C7B6B] text-white text-xs tracking-[0.2em] uppercase font-semibold px-12 py-4 rounded-none hover:bg-[#75665A] transition-colors"
          >
            Login
          </button>
        )}
      </div>
    </div>
  );
}
